import React, { useContext, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiUsers, FiBookOpen, FiChevronDown} from "react-icons/fi";
import { IoSettingsOutline } from "react-icons/io5";
import { DContext } from "../../context/Datacontext";
import { GiShoppingCart } from "react-icons/gi";
import { MdOutlineDashboard } from "react-icons/md";
import { TiShoppingBag } from "react-icons/ti";
import { MdOutlineBookmarkBorder } from "react-icons/md";
import { LuMessageCircleMore } from "react-icons/lu";
import { FaIndianRupeeSign } from "react-icons/fa6";
import Logo from '../../assets/WhatsApp Image 2025-12-17 at 3.56.49 PM.jpeg'

export const Sidebar = ({ mobileOpen, setMobileOpen }) => {
  const { currentUser } = useContext(DContext);
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate()

  const role = currentUser?.role;

  const menuItems = [
    {
      name: "Dashboard",
      icon: MdOutlineDashboard,
      path: "/app/dashboard",
      allowUser: ["admin", "superadmin"],
    },
    {
      name: "Dashboard",
      icon: MdOutlineDashboard,
      path: "/instructor/dashboard",
      allowUser: ["instructor"],
    },
    {
      name: "Manage Users",
      icon: FiUsers,
      allowUser: ["admin", "superadmin"],
      path: "/app/users",
    },
    {
      name: "My Courses",
      icon: FiBookOpen,
      allowUser: ["instructor"],
      path: "/instructor/mycourse",
      // children: [
      //   {
      //     name: "My Course",
          
      //     allowUser: ["instructor"],
      //   },
      //   {
      //     name: "View Course",
      //     path: "/app/managecourse",
      //     allowUser: ["instructor"],
      //   }
      // ],
    },
    {
      name: "Orders",
      icon: MdOutlineBookmarkBorder ,
      allowUser: ["instructor"],
      path: "/instructor/orders",
    },
    {
      name: "Course Library",
      icon: FiBookOpen,
      allowUser: ["admin", "superadmin"],
      path: "/app/courses"
    },
    {
      name: "Pricing",
      icon: FaIndianRupeeSign,
      allowUser: ["admin", "superadmin"],
      path: "/app/course-pricing",
    },
    {
      name: "Communications",
      icon: LuMessageCircleMore,
      path: "/instructor/communications",
      allowUser: ["instructor"],
      // children: [
      //   { name: "Basic Information", path: "/app/instructor/basic-info", allowUser: ["instructor"] },
      //   { name: "Experience", path: "/app/instructor/experience", allowUser: ["instructor"] },
      //   { name: "Education", path: "/app/instructor/education", allowUser: ["instructor"] },
      //   { name: "Social Profile", path: "/app/instructor/social-links", allowUser: ["instructor"] },
      //   { name: "About You", path: "/app/instructor/about", allowUser: ["instructor"] },
      // ],
    },
    {
      name: "Profile",
      icon: FiUsers,
      path: "/instructor/my/profile",
      allowUser: ["instructor"],
      // children: [
      //   { name: "Basic Information", path: "/app/instructor/basic-info", allowUser: ["instructor"] },
      //   { name: "Experience", path: "/app/instructor/experience", allowUser: ["instructor"] },
      //   { name: "Education", path: "/app/instructor/education", allowUser: ["instructor"] },
      //   { name: "Social Profile", path: "/app/instructor/social-links", allowUser: ["instructor"] },
      //   { name: "About You", path: "/app/instructor/about", allowUser: ["instructor"] },
      // ],
    },
    {
      name: "Cart Management",
      icon: GiShoppingCart,
      path : "/app/carts",
      allowUser: ["admin", "superadmin"],
    },
    {
      name: "Orders",
      icon: TiShoppingBag,
      allowUser: ["admin", "superadmin"],
      path : '/app/orders'
    },
    {
      name: "Department",
      icon: IoSettingsOutline,
      allowUser: ["admin"],
      path: "/app/department/create"
    }
  ];

  const isChildActive = (children) =>
    children?.some((child) => location.pathname.startsWith(child.path));

  const filteredMenu = menuItems
    .filter((item) => item.allowUser.includes(role))
    .map((item) => {
      if (!item.children) return item;
      const filteredChildren = item.children.filter((child) =>
        child.allowUser.includes(role)
      );
      return { ...item, children: filteredChildren };
    });

  const toggleMenu = (name) =>
    setOpenMenu(openMenu === name ? null : name);

  return (
    <>
      {/* Mobile Overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <aside
        className={`
          fixed lg:static z-50
          top-0 left-0 h-full
          w-64 bg-white border-r shadow-md
          transform transition-transform duration-300
          ${mobileOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >
        {/* Logo */}
        <div className="h-16 flex items-center px-6 border-b">
          <div onClick={() => navigate("/")} className="cursor-pointer">
            <img src={Logo} alt="logo" className="object-cover h-12" />
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
          {filteredMenu.map((item) => {
            const Icon = item.icon;
            if (!item.children) {
              return (
                <NavLink
                  key={item.name}
                  to={item.path}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium transition ${
                      isActive
                        ? "bg-blue-50 text-blue-600"
                        : "text-gray-600 hover:bg-gray-100"
                    }`
                  }
                >
                  <Icon size={18} />
                  {item.name}
                </NavLink>
              );
            }

            return (
              <div key={item.name}>
                <button
                  onClick={() => toggleMenu(item.name)}
                  className="flex items-center justify-between w-full px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg transition"
                >
                  <div className="flex items-center gap-3">
                    <Icon size={18} />
                    {item.name}
                  </div>

                  <FiChevronDown
                    size={16}
                    className={`transition-transform ${
                      openMenu === item.name || isChildActive(item.children)
                        ? "rotate-180"
                        : ""
                    }`}
                  />
                </button>

                {(openMenu === item.name || isChildActive(item.children)) && (
                  <div className="ml-8 mt-2 space-y-1">
                    {item.children.map((sub) => (
                      <NavLink
                        key={sub.path}
                        to={sub.path}
                        onClick={() => setMobileOpen(false)}
                        className={({ isActive }) =>
                          `block px-3 py-2 text-sm rounded-lg transition ${
                            isActive
                              ? "bg-blue-50 text-blue-600"
                              : "text-gray-500 hover:bg-gray-100"
                          }`
                        }
                      >
                        {sub.name}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </aside>
    </>
  );
};
